<template>
  <BreadCrumb PageTitle="Historique des tâches" />
  <StaffCustomer :userId="userId" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StaffCustomer from "../../components/Customers/StaffCustomer.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "StaffCustomerPage",
  components: {
    BreadCrumb,
    StaffCustomer,
  },

   setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
  }
});
</script>